import { Box, Grid } from "@mui/material";
import logoImg from "assets/logos/logo-transparent.png";
import {
  GamificationContext,
  LockedModalClickFrom,
} from "contexts/Gamification";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import { LANDING_PAGE_LINK } from "constants/influencer";
import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";
import { useLogin } from "utils/useLogin";

import { Page } from "../TopNavigation/schema";
import LeftSideBarIcon from "./Icon";
import styles from "./styles";

function LeftSidebar() {
  const trackPageNavigation = (route: string) => {
    trackEvent("Page Navigated", { route });
  };

  const goToLandingPage = () => {
    trackEvent("Landing Page Logo Clicked", {
      "Clicked From": "Navigation Bar",
    });
    window.open(LANDING_PAGE_LINK, "_blank");
  };

  const { hasRestrictedPlatformAccess } = useLogin();

  const { setOpenLockedModal } = useContext(GamificationContext);

  const { currentOrg } = useContext(OrganizationUserContext);
  return (
    <Box sx={styles.root}>
      <Grid
        item
        container
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
      >
        <Box
          component="img"
          src={logoImg}
          sx={styles.topLogo}
          onClick={goToLandingPage}
        />
        {!currentOrg?.isBrand && (
          <LeftSideBarIcon
            name="Home"
            isActive={isPage(Page.HOME)}
            link={`/dashboard/${Page.HOME}`}
            onClick={() => trackPageNavigation(Page.HOME)}
            icon="fa-thin fa-house-blank"
          />
        )}
        {!currentOrg?.isBrand && (
          <LeftSideBarIcon
            name="Brands"
            isActive={isPage(Page.BRANDS)}
            link={`/dashboard/${Page.BRANDS}`}
            onClick={() => trackPageNavigation(Page.BRANDS)}
            icon="fa-thin fa-search"
          />
        )}
        {!currentOrg?.isBrand && (
          <LeftSideBarIcon
            name="Recos"
            icon="fa-thin fa-heart"
            isActive={isPage(Page.RECOMMENDATIONS)}
            link={`/dashboard/${Page.RECOMMENDATIONS}`}
            onClick={() => trackPageNavigation(Page.RECOMMENDATIONS)}
            locked={hasRestrictedPlatformAccess}
            onLockedClick={() =>
              setOpenLockedModal(LockedModalClickFrom.nav_bar)
            }
          />
        )}
        <LeftSideBarIcon
          name="Inbox"
          icon="fa-thin fa-envelope"
          isActive={isPage(Page.INBOX)}
          link={`/dashboard/${Page.INBOX}`}
          onClick={() => trackPageNavigation(Page.INBOX)}
        />

        <LeftSideBarIcon
          name="Campaigns"
          icon="fa-thin fa-bullseye-arrow"
          isActive={isPage(Page.CAMPAIGNS)}
          link={`/dashboard/${Page.CAMPAIGNS}`}
          onClick={() => trackPageNavigation(Page.CAMPAIGNS)}
          locked={hasRestrictedPlatformAccess}
          onLockedClick={() => setOpenLockedModal(LockedModalClickFrom.nav_bar)}
        />
        {!currentOrg?.isBrand && (
          <LeftSideBarIcon
            name="Local"
            icon="fa-thin fa-location-dot"
            isActive={isPage(Page.LOCAL)}
            link={`/dashboard/${Page.LOCAL}`}
            onClick={() => trackPageNavigation(Page.LOCAL)}
            locked={hasRestrictedPlatformAccess}
            onLockedClick={() =>
              setOpenLockedModal(LockedModalClickFrom.nav_bar)
            }
          />
        )}
        {!currentOrg?.isBrand &&
          (currentOrg?.showAutopilotPlan ? (
            <LeftSideBarIcon
              name="Autopilot"
              icon="fa-thin fa-bolt"
              isActive={isPage(Page.AUTOPILOT)}
              link={`/dashboard/${Page.AUTOPILOT}`}
              onClick={() => trackPageNavigation(Page.AUTOPILOT)}
              locked={hasRestrictedPlatformAccess}
              onLockedClick={() =>
                setOpenLockedModal(LockedModalClickFrom.nav_bar)
              }
            />
          ) : (
            <LeftSideBarIcon
              name="VA"
              icon="fa-thin fa-bolt"
              isActive={isPage(Page.VA)}
              link={`/dashboard/${Page.VA}`}
              onClick={() => trackPageNavigation(Page.VA)}
            />
          ))}
        {!currentOrg?.isBrand && (
          <LeftSideBarIcon
            name="Instagram"
            icon="fa-brands fa-instagram"
            isActive={isPage(Page.INSTAGRAM)}
            link={`/dashboard/${Page.INSTAGRAM}`}
            onClick={() => trackPageNavigation(Page.INSTAGRAM)}
            locked={hasRestrictedPlatformAccess}
            onLockedClick={() =>
              setOpenLockedModal(LockedModalClickFrom.nav_bar)
            }
          />
        )}
      </Grid>
    </Box>
  );
}

export default LeftSidebar;
